import React, { FC } from 'react';
import { DeleteIcon } from 'shared/ui';

interface DeleteColumnBtnProps {
	handleDeleteColumn: () => void;
	testId?: string;
}
const DeleteColumnBtn: FC<DeleteColumnBtnProps> = ({ handleDeleteColumn, testId }) => (
	<div
		style={{
			height: '19px',
			minWidth: '19px',
			marginLeft: '16px',
			cursor: 'pointer',
			paddingTop: '12px',
		}}
	>
		<div onClick={handleDeleteColumn} data-testid={testId}>
			<DeleteIcon />
		</div>
	</div>
);

export default DeleteColumnBtn;
